import React from "react";
import AssayContainer from "../containers/AssayContainer";

const Assay = () => {
    return (
        <div>
            <AssayContainer/>
        </div>
    );
}
export default Assay;